import CollectingInstitutionMain from '../views/collectingInstitution/collecting_institution/CollectingInstitutionMain.vue';
import CollectingInstitutionList from '../views/collectingInstitution/collecting_institution/CollectingInstitutionList.vue';
import CollectingInstitutionCreate from '../views/collectingInstitution/collecting_institution/CollectingInstitutionCreate.vue';
import CollectingInstitutionUpdate from '../views/collectingInstitution/collecting_institution/CollectingInstitutionUpdate.vue';
import CollectingInstitutionView from '../views/collectingInstitution/collecting_institution/CollectingInstitutionView.vue';

export default {
  routes: [
    {
      path: 'collecting-institution', // CollectingInstitutionList
      name: 'collecting-institution',
      component: CollectingInstitutionMain,
      children: [
        {
          path: 'list',
          name: 'collecting-institution.list',
          component: CollectingInstitutionList,
        },
        {
          path: 'create',
          name: 'collecting-institution.create',
          component: CollectingInstitutionCreate,
        },
        {
          path: 'update/:id',
          name: 'collecting-institution.edit',
          component: CollectingInstitutionUpdate,
        },
        {
          path: 'update/:id',
          name: 'collecting-institution.view',
          component: CollectingInstitutionView,
        },
      ],
    },
  ],
};
